import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import { CheckSolidV6, ListUlSolidV6, PhoneSolidV6 } from "@shared/v2/Icomoon";

const DitlCardButton = ({ icon: Icon = null, schema = "primary", onClick = null, children }) => (
  <Button size="medium" schema={schema} className="tw-flex tw-items-center tw-gap-[6px]" onClick={onClick}>
    {Icon && <Icon className="tw-w-[12px] tw-h-[12px]" />}
    {children}
  </Button>
);

DitlCardButton.propTypes = {
  icon: PropTypes.elementType,
  schema: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export const DitlPreviewButton = ({ label = "Preview", onClick = null }) => (
  <DitlCardButton schema="secondary" icon={ListUlSolidV6} onClick={onClick}>
    {label}
  </DitlCardButton>
);

DitlPreviewButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export const DitlCallButton = ({ onClick = null }) => (
  <DitlCardButton schema="solid-green" icon={PhoneSolidV6} onClick={onClick}>
    Call
  </DitlCardButton>
);

DitlCallButton.propTypes = {
  onClick: PropTypes.func,
};

export const DitlGoToTasksButton = ({ onClick = null }) => (
  <DitlCardButton onClick={onClick}>Go to Tasks</DitlCardButton>
);

DitlGoToTasksButton.propTypes = {
  onClick: PropTypes.func,
};

export const DitlDoneButton = ({ onClick = null }) => (
  <DitlCardButton icon={CheckSolidV6} onClick={onClick}>
    Done
  </DitlCardButton>
);

DitlDoneButton.propTypes = {
  onClick: PropTypes.func,
};
